import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import UserIcon from '@material-ui/icons/Person';
import Slide from '@material-ui/core/Slide';
import { useTranslation } from 'react-i18next';
import Box from 'core/ui/Box';
import Grid from 'core/ui/Grid';
import { secondaryBgLight } from 'core/ui/Colors';
import Paper from 'core/ui/Paper';
import Typography from 'core/ui/Typography';
import LoaderSm from 'core/ui/LoaderSm';
import { DialogContent } from '@material-ui/core';
import FormConfig from './FormConfig';
import ManageHeats from './Manage';
import useHeats from './useHeats';
import ModalEditHeat from './ModalEditHeat';
import ModalCloneHeat from './ModalCloneHeat';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalHeats = ({ open, close, workout, buttonColor, fontColor }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    competition,
    loadHeats,
    resetHeats,
    heats,
    loadingHeats,
    loadingLeaderboard,
    leaderboard,
    heatsUsers,
    setHeatsUsers,
    changeHeat,
    modalHeatAction,
    setModalHeatAction,
    createNewHeat,
  } = useHeats({ workout });

  const hasHeats = heats && heats.length > 0;

  return (
    <Dialog
      style={{ marginTop: 100 }}
      fullScreen
      open={!!open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar} color="secondary">
        <Toolbar>
          <UserIcon />
          <Typography variant="h6" className={classes.title}>
            {t(
              heats && heats.length > 0 ? 'workout.heats.title.edit' : 'workout.heats.title.add',
            ).toUpperCase()}
          </Typography>
          <LoaderSm width={20} loading={loadingHeats || loadingLeaderboard} />
          <IconButton edge="start" color="inherit" onClick={close} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent style={{ backgroundColor: secondaryBgLight }}>
        {/* <Scrollbars allowFullScreen style={{ backgroundColor: secondaryBgLight }}> */}
        <Box px={5} py={3} style={{ height: '100%' }}>
          {hasHeats && (
            <>
              <ManageHeats
                heats={heats}
                leaderboard={leaderboard}
                competition={competition}
                workout={workout}
                buttonColor={buttonColor}
                heatsUsers={heatsUsers}
                loadHeats={loadHeats}
                resetHeats={resetHeats}
                setHeatsUsers={setHeatsUsers}
                createHeat={() => setModalHeatAction({ open: true, action: 'new' })}
                cloneHeat={() => setModalHeatAction({ open: true, action: 'clone' })}
                editHeat={(heat) => setModalHeatAction({ heat, open: true, action: 'edit' })}
              />

              {(modalHeatAction?.action === 'edit' || modalHeatAction?.action === 'new') && (
                <ModalEditHeat
                  {...modalHeatAction}
                  close={() => setModalHeatAction({})}
                  changeHeat={changeHeat}
                  createNewHeat={createNewHeat}
                />
              )}
              {modalHeatAction?.action === 'clone' && (
                <ModalCloneHeat
                  {...modalHeatAction}
                  workout={workout}
                  close={() => setModalHeatAction({})}
                />
              )}
            </>
          )}

          {!hasHeats && (
            <>
              <Grid container spacing={5}>
                <Grid item xs={12} md={6} />
                <Grid item xs={12} md={6}>
                  <Paper elevation={2} mb={3} className="paper-rounded opacity-80" p={3}>
                    <Typography mb={3} variant="h5" color="secondary">
                      {t('workout.heat.information').toUpperCase()}
                    </Typography>
                    <FormConfig
                      workoutId={workout.id}
                      buttonColor={buttonColor}
                      fontColor={fontColor}
                      callback={loadHeats}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
        {/* </Scrollbars> */}
      </DialogContent>
    </Dialog>
  );
};

export default ModalHeats;
